import { render, staticRenderFns } from "./NavBarA.vue?vue&type=template&id=5c169c4c&scoped=true"
import script from "./NavBarA.vue?vue&type=script&lang=js"
export * from "./NavBarA.vue?vue&type=script&lang=js"
import style0 from "./NavBarA.vue?vue&type=style&index=0&id=5c169c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c169c4c",
  null
  
)

export default component.exports